import { globalLoadingCountState } from "./ui";

let setGlobalLoadingCountFn = null;

export function registerGlobalLoadingSetter(setter) {
  setGlobalLoadingCountFn = setter;
}

export function incrementGlobalLoading() {
  if (!setGlobalLoadingCountFn) return;
  setGlobalLoadingCountFn((prev) => (typeof prev === "number" ? prev + 1 : 1));
}

export function decrementGlobalLoading() {
  if (!setGlobalLoadingCountFn) return;
  setGlobalLoadingCountFn((prev) => {
    const next = (typeof prev === "number" ? prev : 0) - 1;
    return next > 0 ? next : 0;
  });
}

// 유틸: 명시적 재설정이 필요할 때 사용
export function resetGlobalLoading() {
  if (!setGlobalLoadingCountFn) return;
  setGlobalLoadingCountFn(0);
}
